const emergencyBox1ContentPlugin: any = {
  Renderer: ({ children, data }: any) => (
    <div
      className="emergency-box1-content-outer"
      // style={{ display: "flex", justifyContent: "center" }}
    >
      <div
        className="emergency-box1-content"
        style={{
          backgroundColor: data.backgroundColor,
          boxShadow: '0px 1px 2px 0px rgba(0,0,0,0.5)',
          // position: "relative"
          margin: '0 auto',
          // marginTop: -35,
          padding: 10,
          paddingTop: 30,
          maxWidth: 300,
        }}
      >
        {children}
      </div>
    </div>
  ),

  id: 'emergency-content-plugin',
  title: 'Content Box',
  // description: 'emergency content plugin',
  version: 1,
  controls: {
    type: 'autoform',
    schema: {
      required: ['backgroundColor'],
      properties: {
        backgroundColor: { type: 'string' },
      },
    },
  },
};

export default emergencyBox1ContentPlugin;
